// extracted by mini-css-extract-plugin
export default {"CTA":"CTA_CTA__QalMm","hoverEffect":"CTA_hoverEffect__Y9AEU"};